<template>
    <div>
        <h1 style="font-size: 24px; color: black;">任务管理</h1>
        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">删除用户</h2>
            <el-form-item label="用户id：">
                <el-input style="width: 300px" placeholder="用小写的逗号分割" v-model="clean.ids"></el-input>
            </el-form-item>
            <el-form-item label="删除结果：">
                <el-input style="width: 300px" placeholder="删除结果" v-model="clean.result"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="cleanF">删除</el-button>
            </el-form-item>
        </el-form>
        <el-tabs type="card" v-model="selectedTaskType" @tab-click="changeTaskType">
            <el-tab-pane v-for="item in iosTaskSelections.taskTypes" :name="item.id+'' " :key="item.id"
                         :label="item.name">
            </el-tab-pane>
        </el-tabs>
        <el-button type="primary" @click="showDetails('添加任务')">添加</el-button>
        <h1>
            <el-table :data="list" border>
                <el-table-column label="任务ID" prop="id" align="center"></el-table-column>
                <el-table-column label="任务名称" prop="name" align="center"></el-table-column>
                <el-table-column label="任务英文名称" prop="nameEN" align="center"></el-table-column>
                <el-table-column label="任务繁体中文名称" prop="nameTCN" align="center"></el-table-column>
                <el-table-column label="奖励" align="center" prop="rewards">
                    <template slot-scope="scope">
                        {{ scope.row.rewards | iosRewardFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="领取类型" prop="obtainType.name" align="center"></el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state === 1" type="success" size="small" plain
                                   @click="updateState(scope.row)">正常
                        </el-button>
                        <el-button v-if="scope.row.state === 0" type="danger" size="small" plain
                                   @click="updateState(scope.row)">关闭
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建日期" prop="createDt" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="更新日期" prop="updateDt" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.updateDt | dateTimeFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑任务',scope.row)">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10,20,30]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="page.totalElements">
        </el-pagination>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="taskForm">
                <el-form-item label="任务名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="任务英文名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.nameEN" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="任务繁体中文名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.nameTCN" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="状态 :" :label-width="labelWidth">
                    <el-radio-group v-model="taskForm.state">
                        <el-radio :label="1">开始</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="领取类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.obtainType" placeholder="请选择">
                        <el-option
                            v-for="item in iosTaskSelections.obtainTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖励类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.rewardType" placeholder="请选择">
                        <el-option
                            v-for="item in iosTaskSelections.rewardTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.achieveType" placeholder="请选择">
                        <el-option
                            v-for="item in iosTaskSelections.achieveTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="达成条件数 :" :label-width="labelWidth">
                    <el-input-number size="mini" :min="1" v-model="taskForm.number"></el-input-number>
                </el-form-item>
                <el-form-item :label-width="labelWidth">
                    <el-button size="mini" type="primary" @click="addGoods">新增奖励</el-button>
                    <el-table :data="taskForm.goodsList"
                              border
                              :fit="true">
                        <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
                        <el-table-column label="奖励" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.goodsId" placeholder="请选择">
                                    <el-option
                                        v-for="item in goods"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="奖励数量" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.number"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80px">
                            <template slot-scope="scope">
                                <el-button circle icon="el-icon-minus" size="mini" type="danger"
                                           @click.native.prevent="reduceGoods(scope.$index,taskForm.goodsList)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item :label-width="labelWidth" v-if="taskForm.rewardType===2 || taskForm.rewardType===3">
                    <el-button size="mini" type="primary" @click="addProbability">新增随机奖励</el-button>
                    <el-table :data="taskForm.probabilityList"
                              border
                              :fit="true">
                        <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
                        <el-table-column label="随机奖励数量" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.number"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="随机概率" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.probability"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80px">
                            <template slot-scope="scope">
                                <el-button circle icon="el-icon-minus" size="mini" type="danger"
                                           @click.native.prevent="reduceProbability(scope.$index,taskForm.probabilityList)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="图片" :label-width="labelWidth">
                    <el-upload
                        :headers="headers"
                        :action="uploadURL"
                        list-type="picture-card"
                        :on-success="handleImageSuccess"
                        :on-remove="handleImgRemove"
                        limit="3"
                        :before-upload="beforeAvatarUpload"
                        :file-list="fileList">
                        <i class="el-icon-plus"></i>
                        <el-alert slot="tip"
                                  title="上传成功画框会有绿色对钩标识，视频组件不支持内容回显"
                                  type="success"
                                  center
                                  show-icon>
                        </el-alert>
                    </el-upload>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm">提 交</el-button>
                    <el-button type="info" @click="cancelForm">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {goodsSelections, saveTask, searchTask, updateTaskState} from "@/http/iosApi";
import store from '@/store';
import settingMix from '@/utils/mix/common-setting';
import {clean} from "../../http/iosUserApi";

export default {
    name: "TaskManage",
    mixins: [settingMix],
    data() {
        return {
            VUE_APP_IOS_URL: '',
            VUE_APP_CDN_URL: '',
            selectedTaskType: "",
            needIosTaskSelections: true,
            uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
            labelWidth: '110px',
            headers: {},
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            list: [],
            queryData: {
                "orders": "id asc ",
            },
            goods: [],
            iosTaskSelections: {},
            dialogTitle: '',
            dialogVisible: false,
            taskForm: {},
            fileList: [],
            clean: {
                ids: ',',
                result: ''
            },
        }
    },
    methods: {
        changeTaskType(tab) {
            this.$store.commit('changeSelectedTaskType', tab.name);
            this.selectedTaskType = tab.name;
            //this.addTaskForm.taskType= tab.name;
            this.page.page = 1;
            this.search();
        },
        search() {
            this.queryData.taskType = parseInt(this.selectedTaskType);
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchTask(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements
            })
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.search();
        },
        handleImageSuccess(response) {
            const temp = {name: null, url: null, postUrl: null};
            const url = response.info;
            const array = url.split('/');
            temp.name = array[array.length - 1];
            //这里拼接对象进去   获取展示数据的时候可能需要解析数组 提交数据的时候需要组合数组
            temp.url = process.env.VUE_APP_CDN_URL + url;
            temp.postUrl = url;
            this.fileList.push(temp);
        },
        handleImgRemove(file) {
            const i = this.fileList.findIndex(x => x.name === file.name);
            this.fileList.splice(i, 1)
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isGif = file.type === "image/gif";
            const isMp4 = file.type === "video/mp4";
            const isPG = isJPG || isPNG || isGif;
            if (isPG) {
                //限制图片格式为jpg / png
                if (file.size / 1024 / 1024 > 1) {
                    this.$message.error("上传图片应该小于1M，请重新上传");
                    return false;
                }
            } else if (isMp4) {
                if (file.size / 1024 / 1024 > 5) {
                    this.$message.error("上传视频应该小于5M，请重新上传");
                    return false;
                }
            }
        },
        updateState(row) {
            this.$confirm('此操作将关闭任务, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let taskId = row.id;
                let state = row.state === 0 ? 1 : 0;
                updateTaskState(taskId, state).then(resp => {
                    if (resp.data.status === 1) {
                        this.search();
                    }
                })
            }).catch(() => {
            })
        },
        goodsSelections() {
            goodsSelections().then(resp => {
                this.goods = resp.data.info;
            })
        },
        showDetails(title, row) {
            this.goodsSelections();
            this.taskForm = {
                "id": 0,
                "name": "",
                "nameEN": "",
                "nameTCN": "",
                "state": 1,
                "number": 1,
                "taskType": this.selectedTaskType,
                "obtainType": 1,
                "rewardType": 1,
                "achieveType": 1,
                "goodsList": [],
                "probabilityList": [],
            };
            this.dialogTitle = title;
            this.dialogVisible = true;

            function chargeReward(list) {
                let newRewards = [];
                list.forEach((item) => {
                    newRewards.push({
                        goodsId: item.goods.id,
                        number: item.number
                    })
                });
                return newRewards
            }

            function chargePro(list) {
                let newProbability = [];
                list.forEach((item) => {
                    newProbability.push({
                        number: item.number,
                        probability: item.probability
                    })
                });
                return newProbability
            }

            function chargeImage(image) {
                let file = [];
                let list = image.split(",");
                list.forEach((item) => {
                    const temp = {name: null, url: null, postUrl: null};
                    const url = item;
                    const array = url.split('/');
                    temp.name = array[array.length - 1];
                    temp.url = process.env.VUE_APP_CDN_URL + url;
                    temp.postUrl = url;
                    file.push(temp)
                });
                return file;
            }

            if (row) {
                this.taskForm = {
                    "id": row.id,
                    "name": row.name,
                    "nameEN": row.nameEN,
                    "nameTCN": row.nameTCN,
                    "state": row.state,
                    "number": row.number,
                    "taskType": row.taskType,
                    "obtainType": row.obtainType.id,
                    "rewardType": row.rewardType.id,
                    "achieveType": row.achieveType.id,
                    "goodsList": chargeReward(row.rewards),
                    "probabilityList": chargePro(row.probabilities)
                };
                this.fileList = chargeImage(row.image);
            }
        },
        addGoods() {
            this.taskForm.goodsList.push({
                goodsId: 1,
                number: 0
            })
        },
        reduceGoods(index, rows) {
            rows.splice(index, 1);
        },
        addProbability() {
            this.taskForm.probabilityList.push({
                number: 0,
                probability: 20
            })
        },
        reduceProbability(index, rows) {
            rows.splice(index, 1);
        },
        confirmForm() {
            let _message = '';
            if (this.taskForm.name === '') {
                _message = '请输入策略名称'
            } else if (this.taskForm.goodsList.length < 1) {
                _message = '请添加奖励配置'
            } else if (this.taskForm.rewardType === 2 && this.taskForm.goodsList.length < this.taskForm.probabilityList.length) {
                _message = '随机奖励不能超过奖品数'
            } else if (this.taskForm.rewardType === 2 && this.taskForm.probabilityList.length < 1) {
                _message = '请添加随机奖励配置'
            } else if (isRepeat(this.taskForm.goodsList)) {
                _message = '请勿重复配置奖品'
            } else if (this.taskForm.rewardType === 2 && isFull(this.taskForm.probabilityList)) {
                _message = '请达到百分百'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }

            function isRepeat(list) {
                return false;
                // let ids=[];
                // list.forEach((item)=>{
                //    ids.push(item.goodsId)
                // });
                // var set = new Set(ids);
                // return ids.length !== set.size;
            }

            function isFull(list) {
                let num = 0;
                list.forEach((item) => {
                    num += item.probability
                });
                return num !== 100;
            }

            function transImage(list) {
                let url = [];
                list.forEach((item) => {
                    url.push(item.postUrl)
                });
                return url;
            }

            this.taskForm.image = transImage(this.fileList);
            saveTask(this.taskForm).then(resp => {
                if (resp.data.status === 0) {
                    this.search();
                    this.dialogVisible = false;
                }
            });
        },
        cancelForm() {
            this.dialogVisible = false;
            this.fileList = [];
        },
        cleanF() {
            clean(this.clean).then(resp => {
                this.clean.result = resp.data.msg;
            })
        },
    },
    mounted() {
        this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.selectedTaskType = store.state.newProjectVersion.selectedTaskType,
            this.search();
    }
}
</script>

<style scoped>

</style>
